<mat-toolbar>


	<mat-menu #menuReports="matMenu">
		<!-- <button mat-menu-item *ngFor="let s of menu[0].kids" [routerLink]="s.url" [hidden]="!menuAllowed[s.url]"> -->
			<button mat-menu-item *ngFor="let s of menu[0].kids" [routerLink]="s.url" >
			{{s.name}}</button>
	</mat-menu>
	<!-- <button mat-button [matMenuTriggerFor]="menuReports" [hidden]="!menuAllowed[menu[0].name]"> -->
		<button mat-button [matMenuTriggerFor]="menuReports" >
		Reports
		<span class="material-icons">arrow_drop_down</span>
	</button>

	<mat-menu #menuAdmin="matMenu">
		<!-- <button mat-menu-item *ngFor="let s of menu[1].kids" [routerLink]="s.url" [hidden]="!menuAllowed[s.url]">{{s.name}}</button> -->
		 	<button mat-menu-item *ngFor="let s of menu[1].kids" [routerLink]="s.url" >{{s.name}}</button>
	</mat-menu>
	<!-- <button mat-button [matMenuTriggerFor]="menuAdmin" [hidden]="!menuAllowed[menu[1].name]"> -->
		<button mat-button [matMenuTriggerFor]="menuAdmin" >
		Admin
		<span class="material-icons">arrow_drop_down</span>
	</button>

	<mat-menu #menuCfg="matMenu">
		<button mat-menu-item *ngFor="let s of menu[2].kids" [routerLink]="s.url" [hidden]="!menuAllowed[s.url]">{{s.name}}</button>
	</mat-menu>
	<button mat-button [matMenuTriggerFor]="menuCfg" [hidden]="!menuAllowed[menu[2].name]">
		Config
		<span class="material-icons">arrow_drop_down</span>
	</button>

	<button mat-button [routerLink]="'p/help'">
		Help
	</button>

	<span class="helper-fill-remaining-space"></span>

	<div class="mr-4 menu-user-groups" (click)="hideUserOverrideModal = !hideUserOverrideModal" style="margin-right: 10px">
		<span>{{loginData.login}}</span>

		<div style="margin-left: 15px;float: right" [hidden]="!debug.isLocal">
			<span *ngFor="let g of loginData.groups;let i = index" class="helper-lowercase menu-user-group {{i==0?'first':''}}">{{formatGroupeName(g)}}</span>
		</div>
	</div>

	<div *ngIf="debug.active" class="card" style="position: relative;margin-top: 425px;background: white;z-index: 10000" [hidden]="hideUserOverrideModal">
		<div class="card-header" style="background: #3b4045" *ngIf="debug.active">
			User Override
		</div>
		<div class="card-body" *ngIf="debug.active">
			<input class="form-control" placeholder="user name" [(ngModel)]="debug.username"/>

			<div *ngFor="let r of debug.roles">
				<label style="margin:0">
					<input type="checkbox" [(ngModel)]="debug.rolesSelected[r]">
					<span style="color:black; text-transform: lowercase;font-weight: normal;font-size: 14px">&nbsp;{{r}}</span>
				</label>
			</div>

			<button class="btn btn-primary" (click)="debugChangeToken()">Override</button>

			<div class="card-body ">
				<div class="row">
					<div class="col-lg-6">
						<button style="width: 100%" class="btn btn-danger" (click)="logout()">Logout</button>
					</div>
					<div class="col-lg-6">
						<button style="width: 100%;background: #ccc" class="btn" (click)="hideUserOverrideModal=true">Close</button>
					</div>
				</div>


			</div>
		</div>
	</div>
	<a href="#" style="color: white;text-decoration: none">QAR/SOD</a>
</mat-toolbar>

<p class="alert alert-warning" *ngIf="appNeedUpdate" (click)="updateAppToLatestVersion()" style="cursor: pointer">
	There is a new version available, please click here to update
</p>

<div id="okta-message" style="margin-top: 10px">
	
</div>
<div id="content">
	<router-outlet></router-outlet>

</div>


<!--
<ul style="    position: fixed;list-style: none;
    top: 0;
    right: 0;
    width: 300px;
    padding: 10px;
    height: 100%;
    background: #3b4045">
	<li><h1 class="blue">Roadmap
		<span class="badge {{total()>=50?'badge-success':'badge-danger'}}">{{total()|number}}%</span>
	</h1></li>
	<li *ngFor="let d of data.screens" style="padding: 5px;margin:0">
		<div class="white" (click)="showStory(d)">{{d.name}}
			<span class="badge {{d.percentage>=50?'badge-success':'badge-danger'}}">{{d.percentage}}%</span>
		</div>
		<div *ngIf="d.visible" style="color:white;padding: 10px">
			<a *ngIf="d.url" [routerLink]="d.url">load in app</a>
			<span *ngIf="d.url"> | </span>
			<a *ngIf="d.ado" target="_blank" [href]="'https://hccins.visualstudio.com/QARSOD/_workitems/edit/'+d.ado">load in ADO ({{d.ado}})</a>

			<div>to do:</div>
			<ul>
				<li *ngFor="let td of d.todo">
					{{td}}
				</li>
			</ul>
		</div>
	</li>
</ul>
-->
